module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAABB0lEQVQoU32Qzy7EUBjFz+mMTPybiBexlWivrbFgJ5lEJFjYeQYewENYuJVYG9sRESGxtGJthZQG0dEe6VQ705q4y/Od37nfd4jKU6fVQPB+BWkCUW2em91g2MI/wJHpgGhlum4Qfrjcue3lvhIgaw4BbJRChDPcOyvc636negHo2J2DnH0kAshlAHVIp3AYAzxg+/yiBAynypoA0jTGXsa5dheVbpC/6OV0f2uBsN4riCkk0QzXr99yQP6CR1kjfMZNbl+GxcB6JwBreHpsc/fhqx+Urm+9OAMm4yZXB0C1ueJn30QZUH9uVHcdCVnTywAorbPoepT5V9uirLsEOrP/mAYjJeEPYs1r00w7LVkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/route/upload.png
// module id = 7B8O
// module chunks = 2